import request from '@/router/axios';

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'false' ? '/sys' : '/sys'
//查询纪念日总量
export function getAnniversaryCount(obj) {
  return request({
    url: urlPrefix + '/anniversary/getAnniversaryCount/',
    method: 'post',
    params: obj
  });
}
//纪念日列表
export function getDifferentAnni(obj) {
  return request({
    url: urlPrefix + '/anniversary/getDifferentAnni/',
    method: 'post',
    params: obj
  });
}
//导出
export function exportExcle(obj) {
    return request({
      url: urlPrefix + '/anniversary/export/',
      method: 'POST',
      data: obj,
      responseType: 'arraybuffer',
    });
  }
